import {
	CMP_COLOR_NAVIGATION_TEXT_LINK_FOREGROUND_DEFAULT_DARK,
	SYS_SPACE_FIXED_300,
} from '@oneaudi/unified-web-alpha-common';
import styled from 'styled-components';

export const StyledPopover = styled.div`
	.popover--trigger {
		display: flex;
		align-items: center;
		color: ${CMP_COLOR_NAVIGATION_TEXT_LINK_FOREGROUND_DEFAULT_DARK};
		font-family: AudiType, sans-serif;
	}

	.popover--root {
		padding: 24px 12px;
	}

	.popover--body {
		display: flex;
		flex-direction: column;
		gap: 1rem;
	}
`;

export const PopoverContentStyle = styled.div<{ $show: boolean }>`
	border-radius: 24px;
	display: flex;
	flex-direction: column;
	padding: ${SYS_SPACE_FIXED_300};
	gap: 12px;
	pointer-events: all;
	background: ${(props) => props.theme.sys.gradient.elevation.level2.fill};
	filter: drop-shadow(rgba(0, 0, 0, 0.04) 0px 10px 8px) drop-shadow(rgba(0, 0, 0, 0.1) 0px 4px 3px);
	opacity: ${(props) => (props.$show ? 1 : 0)};
	position: absolute;
	top: 24px;
	left: 0;
	width: 100%;
	pointer-events: all;
	z-index: ${(props) => (props.$show ? 1999 : 0)};
	visibility: ${(props) => (props.$show ? 'visible' : 'hidden')};
`;
